import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FIELD_TYPES } from '../../../../common/globals';
import DescriptionEditor from '../../FormDetails/DescriptionEditor';

class AttachmentElementDetails extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleOnChange = (ev) => {
    const { target } = ev;
    const { onFormElementChange } = this.props;

    onFormElementChange(target);
  };

  handleMultipleFileToggle = (ev) => {
    const {
      checked
    } = ev.target;
    
    const { onFormElementTypeChange } = this.props;

    if (checked) {
      onFormElementTypeChange(FIELD_TYPES.MULTIPLE_FILES);
    }
    else {
      onFormElementTypeChange(FIELD_TYPES.SINGLE_FILE);
    }
  };

  handleRequiredChange = () => {
    const {
      element,
      onFormElementRequiredChange
    } = this.props;

    onFormElementRequiredChange(element.id);
  };

  handleMoveUp = () => {
    const {
      element,
      onMoveUp
    } = this.props;

    const { id } = element;
    onMoveUp(id);
  };

  handleMoveDown = () => {
    const {
      element,
      onMoveDown
    } = this.props;

    const { id } = element;
    onMoveDown(id);
  };
  
  render() {
    const {
      element
    } = this.props;
    
    const {
      type,
      title,
      description,
      required
    } = element;

    const isMultipleFile = type === 'array';

    return (
      <div>
        <div className="form-group">
          <label htmlFor="title">
            Title
          </label>
          <input
            id="title"
            type="text"
            name="title"
            className="form-control"
            value={title}
            onChange={this.handleOnChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Description
          </label>
          <DescriptionEditor
            markdown={description || ''}
            onMarkdownChange={(md) => {
              const { onFormElementChange } = this.props;
              onFormElementChange({ name: 'description', value: md });
            }}
          />
        </div>
        <div className="form-group checkbox">
          <label htmlFor="required">
            <input
              id="required"
              type="checkbox"
              name="required"
              checked={required}
              onChange={this.handleRequiredChange}
            />
            <span className="cr">
              <i className="cr-icon glyphicon glyphicon-ok" />
            </span>
            Required
          </label>
        </div>
        <div className="form-group checkbox">
          <label htmlFor="isMultipleFile">
            <input
              id="isMultipleFile"
              type="checkbox"
              name="isMultipleFile"
              checked={isMultipleFile}
              onChange={this.handleMultipleFileToggle}
            />
            <span className="cr">
              <i className="cr-icon glyphicon glyphicon-ok" />
            </span>
            Allow to select more than 1 file
          </label>
        </div>
        <div className="form-group">
          <label>
            Position
          </label>
          <div className="move-buttons-container">
            <button
              type="button"
              className="btn btn-default"
              onClick={this.handleMoveUp}
            >
              Move up
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-default"
              onClick={this.handleMoveDown}
            >
              Move down
            </button>
          </div>
        </div>
      </div>
    );
  }
}

AttachmentElementDetails.propTypes = {
  element: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    default: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
    format: PropTypes.string,
    enum: PropTypes.arrayOf(PropTypes.string),
    required: PropTypes.bool
  }).isRequired,
  onFormElementChange: PropTypes.func.isRequired,
  onFormElementTypeChange: PropTypes.func.isRequired,
  onFormElementRequiredChange: PropTypes.func.isRequired,
  onMoveUp: PropTypes.func.isRequired,
  onMoveDown: PropTypes.func.isRequired
};

export default AttachmentElementDetails;
